import React from 'react';
import { Text, TextProps } from '@mantine/core';
import { H1Medium as H1MediumStyle } from 'theme/typography';

interface H1MediumProps extends TextProps {
  customStyle?: React.CSSProperties;
  children: React.ReactNode; // Explicitly define the children prop
}

/**
 * Applies the H1Medium typography style.
 */
const H1Medium: React.FC<H1MediumProps> = ({ children, customStyle, ...restProps }) => {
  return (
    <Text {...restProps} style={{ ...H1MediumStyle, ...customStyle }}>
      {children}
    </Text>
  );
};

export default H1Medium;
